import { section as sectionData } from "shared/data/section";

import {
  StyledExplainedLogo,
  StyledScmpFilmsLogo,
  StyledSeriesLogo,
  StyledSpotlightLogo,
  StyledTalkingPostLogo,
} from "./styles";

export const getLogo = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return <StyledExplainedLogo />;
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return <StyledScmpFilmsLogo />;
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return <StyledTalkingPostLogo />;
    case "scmp_series_top":
      return <StyledSeriesLogo />;
    case "scmp_spotlight_top":
      return <StyledSpotlightLogo />;
    default:
      return <div />;
  }
};

export const getDescription = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return "Exploring the story behind the story, Explained demystifies the complex and fascinating realities of life in China, Hong Kong and wider Asia";
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return "Must-watch South China Morning Post video featuring extraordinary stories from Hong Kong, China and around Asia.";
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "Conversations with people who matter to help you to understand what’s important in today’s world of fast-paced news";
    case "scmp_series_top":
      return "Your source for credible news and authoritative insights from Hong Kong, China and the world.";
    case "scmp_spotlight_top":
      return "Curated collections of our most-read stories, award-winning infographics, exclusive interviews, in-depth documentaries and more";
    default:
      return "";
  }
};

export const getMetaTitle = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return "Explained";
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return "SCMP Films";
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "Talking Post";
    case "scmp_series_top":
      return "SCMP Series";
    case "scmp_spotlight_top":
      return "SCMP Spotlight";
    default:
      return "";
  }
};

export const getOpenGraphImageUrl = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return "https://www.scmp.com/static/img/icons/scmp-meta-1200x630.png";
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return "https://www.scmp.com/static/img/og/OG_scmp_films.png";
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "https://www.scmp.com/static/img/icons/scmp-meta-1200x630.png";
    case "scmp_series_top":
      return "https://www.scmp.com/static/img/og/OG_scmp_series@2x.png";
    case "scmp_spotlight_top":
      return "https://www.scmp.com/static/img/og/OG_scmp_spotlight.png";
    default:
      return "";
  }
};

export const getAdditionalKeyword = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return "Explained";
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return "SCMP Films, video";
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "Talking Post, video";
    case "scmp_series_top":
      return;
    case "scmp_spotlight_top":
      return "infographic, video, photo, podcast, multimedia";
    default:
      return;
  }
};

export const getImageAspectRatio = (queueName: string) => {
  switch (queueName) {
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "auto 16 / 9";
    default:
      return;
  }
};

export const getShouldShowContentTypeIcon = (queueName: string) => {
  switch (queueName) {
    case "scmp_spotlight_top":
      return true;
    default:
      return false;
  }
};

export const getShouldShowDefaultImage = (queueName: string) => {
  switch (queueName) {
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return true;
    default:
      return false;
  }
};

export const getContentItemVariant = (queueName: string) => {
  switch (queueName) {
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "talking-post";
    case "scmp_series_top":
      return "series";
    case "scmp_spotlight_top":
      return "spotlight";
    default:
      return "others";
  }
};

export const getPath = (queueName: string) => {
  switch (queueName) {
    case `section_top_${sectionData.explained.entityId}`:
      return "/explained";
    case `video_section_picks_${sectionData.scmpFilms.entityId}`:
      return "/scmp-films";
    case `video_section_picks_${sectionData.talkingPost.entityId}`:
      return "/talking-post";
    case "scmp_series_top":
      return "/series";
    case "scmp_spotlight_top":
      return "/scmp-spotlight";
    default:
      return "/special-index";
  }
};
